import { render } from "./UserGuideline.vue?vue&type=template&id=78fa804a&scoped=true"
import script from "./UserGuideline.vue?vue&type=script&lang=js"
export * from "./UserGuideline.vue?vue&type=script&lang=js"

import "./UserGuideline.vue?vue&type=style&index=0&id=78fa804a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fa804a"]])

export default __exports__